import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "section content" }
const _hoisted_2 = { class: "panel" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "panel-heading" }, "My Apps", -1)
const _hoisted_4 = { class: "panel-block" }
const _hoisted_5 = {
  class: "columns is-multiline is-centered",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ebiz_apps_item = _resolveComponent("ebiz-apps-item")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("nav", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.apps, (app, index) => {
            return (_openBlock(), _createBlock(_component_ebiz_apps_item, {
              key: index,
              title: app.title,
              label: app.label,
              icon: app.icon,
              href: _ctx.getAppAbsoluteUrl(app.href)
            }, null, 8, ["title", "label", "icon", "href"]))
          }), 128))
        ])
      ])
    ])
  ]))
}